
# This file is used by WEB and TOUCH - if you modify this file verify BOTH !

FacetLoader = require './facet-loader'
QueryBuilder = require './QueryBuilder'
paginationCard = require './pagination-card'
urlUtils = require './url-utils'
{objectsMatch, basicDebounce} = require './collection-utility'

priceRangeTemplate = require '../../merchandising_occasions/shared/price-range.html.mustache'
priceRangeCustTemplate = require '../../merchandising_occasions/shared/price-range-custom.html.mustache'
facetTemplate = require '../../merchandising_occasions/shared/facet-template.html.mustache'
radioTemplate = require '../../merchandising_occasions/shared/radios.html.mustache'

hoganPartials = require './template-include-partials'
loadMoreTemplate = require '../../merchandising_occasions/shared/load-more-deals.html.mustache'

getCardUi = ()->
  if typeof CardUI != "object"
    return {init: ()->}
  return CardUI

_forEle = (context, selector, fn) ->
  _forEleList(context.querySelectorAll(selector), fn)

_forEleList = (elements, fn) ->
  elements.forEach fn

_docQs = (sel) ->
  document.querySelector(sel)

_docQsAll = (sel) ->
  document.querySelectorAll(sel)

_docId = (id) ->
  document.getElementById(id)

Filtering = do ->

  lastRequest = ""
  pageConfig = null
  createHeadings = false
  paginatedDealIds = {}
  lhnFacets = {}
  LIMIT_INCREMENT = 10
  MIN_PAGE_DEALS = 4
  extraQueryString = ""
  initialQueryString = {}
  lastState = {}
  fragmentParams = {}
  _attr_dataFilterQuery = "data-filter-query"
  _attr_dataHrefTemplate = "data-href-template"
  _attr_dataNextOffset = "data-next-offset"
  _attr_dataSetId = "data-set-id"
  _attr_dataTotalDeals = "data-total-deals"
  _cls_loadMoreChoices = "load-more-choices"
  _id_loadMoreDeals = "load-more-deals"
  _jsModulesMrchOcsn = "js.modules.merchandising_occasions"
  _sel_loadMoreChoices = "."+_cls_loadMoreChoices
  _sel_loadMoreDeals = "#"+_id_loadMoreDeals
  _sel_priceFilter = "#price-filter"
  _id_pagination_facets_loading = _id_loadMoreDeals+"-pagination-is-loading"

  _touchBtnIds = {
    price   : 'price-filter-trigger'
    facets  : 'facet-filters-trigger'
    sorts   : 'result-sorts-trigger'
    ratings : 'result-ratings-trigger'
    area    : 'facet-area-trigger'
    brand   : 'brand-filter-trigger'
    location: 'location-filter-trigger'
  }

  _prependIfInQuery = (existing, queryKeys...) ->
    for queryKey in queryKeys
      if initialQueryString[queryKey]
        existing = initialQueryString[queryKey] + ',' + existing
    return existing

  _init = (pageCfg, createHeadings, queryExtra, initDoneCb) ->
    pageConfig = pageCfg

    defaultLoadMore = _docQs _sel_loadMoreDeals
    if defaultLoadMore
      updatePaginationCardHref defaultLoadMore
      defaultLoadMore.addEventListener 'click', loadMoreDealsEvent

    extraQueryString = queryExtra if queryExtra
    initialQueryString = urlUtils.parseQueryString(window.location.search)

    lhnFacets = new FacetLoader(pageConfig.facets, {
      subnavFacets: {
        search: pageConfig.subnavFacets
        require: pageConfig.subnavFacetsMinimumDeals
        max: pageConfig.subnavFacetsMax
      },
      facetAreaFacets: {
        search: pageConfig.subnavFacetAreaFacets
        require: pageConfig.subnavFacetAreaMinimumDeals
        max: pageConfig.subnavFacetAreaMax
      },
      paginationFacets: {
        search: pageConfig.paginationFacets
        require: pageConfig.paginationFacetsMinimumDeals
      },
      localityFacets: {
        search: _prependIfInQuery(pageConfig.locationFacets || "city,neighborhood", "city", "neighborhood")
        require: pageConfig.locationFacetsMinimumDeals
        max: pageConfig.locationFacetsMax
      },
      brandFacets: {
        search: _prependIfInQuery(pageConfig.brandFacets || "brand_uuid", "brand_uuid")
        require: pageConfig.brandFacetsMinimumDeals
        max: pageConfig.brandFacetsMax
        moreAlphaSort: true
      }
    })

    showSubnavFacets('subnavFacets')
    showSubnavAreaFacets(lhnFacets.loadedFacets.facetAreaFacets, createHeadings)
    showSubnavLocationFacets('localityFacets', createHeadings)
    showSubnavBrandFacets('brandFacets', createHeadings)

    showPriceFilters(createHeadings)
    showRatingFilters(createHeadings)
    showSortOptions(createHeadings)

    initAtEnd(initDoneCb)

  initAtEnd = (initDoneCb) ->
    setTimeout ()->
      initPaginatedDealIds()
      initRoutes()
      initDoneCb?()
      window.MerchFiltering.lhnFacets = lhnFacets
    , 0

  initCui = () ->
    getCardUi().init()

  initRoutes = () ->
    fragmentParams = urlUtils.parseLocationHash()
    if history.replaceState
      # we should parse the current state and store it here
      query = initialQueryString
      qs = urlUtils.buildQueryString(query)
      history.replaceState({stateQuery:query},document.title,window.location.pathname + qs + urlUtils.currentFragment())
      applyState {stateQuery:query}, () =>
        # TODO: consider moving the following into a "process fragment" function that can be called automatically after state is applied...
        if fragmentParams.offset
          if fragmentParams.setId and pageConfig.showSubnavFacets
            showLoadMoreChoicesBtns lastUl(), fragmentParams
          else
            setupInitialOffset fragmentParams
        else if fragmentParams.deal
          dealHref = unescape(fragmentParams.deal)
          scrollElementIntoView(_docQs("a[href='#{dealHref}']"))
        if not _docId(_id_loadMoreDeals) # the results are exhausted - we may show the extra choices if they are enabled
          showLoadMoreChoicesBtns lastUl()
    window.addEventListener('popstate', popState)

  popStateCallback = () ->
    #Do nothing

  popState = (ev) ->
    if ev?.state?.stateQuery and not objectsMatch(lastState, ev.state.stateQuery)
      applyState(ev.state, popStateCallback, true)

  uncheck = (ele) ->
    ele.checked = false

  applyCheckboxState = (allCounters, myCounterId, catType, category) ->
    inputId = "facet_#{catType}_#{category}"
    input = _docId(inputId)
    if input
      input.checked = true
      _docId("modal-#{inputId}")?.checked=true
    else
      allCounters.missingCheckboxCount++
    allCounters.checkboxCount++
    allCounters[myCounterId] = 0 if !allCounters[myCounterId]
    allCounters[myCounterId]++

  applyState = (state, callback, hasHistoryChanged) ->
    hasCats = hasHistoryChanged || false
    allCounters = {
      missingCheckboxCount: 0
      checkboxCount: 0
      priceCount: 0
      facetCount: 0
      sortCount: 0
      ratingCount: 0
      areaCount: 0 # todo?
      locCount: 0
      brandCount: 0
    }
    if state and state.stateQuery
      _forEle document, 'ul.gift-sidebar input:checked', uncheck
      _forEle document, '#more-filters-modal-content input:checked', uncheck
      stateQuery = state.stateQuery
      for catType of stateQuery
        typeFirst8 = catType.substr(0,8)
        if typeFirst8 in ['topcateg', 'subcateg'] || catType in ['category', 'deal_type'] # please note ['category', 'subcateg'] is not an Array - check the compiled JS and avoid using [].indexOf
          hasCats = true
          categories = stateQuery[catType].split(',')
          for category in categories
            applyCheckboxState(allCounters, 'facetCount', catType, category)
        else if typeFirst8 in ['neighbor', 'city']
          hasCats = true # bad variable name, just reusing it
          locations = stateQuery[catType].split(',')
          for loc in locations
            applyCheckboxState(allCounters, 'locCount', catType, loc)
        else if catType == 'brand_uuid'
          hasCats = true # bad variable name, just reusing it
          brands = stateQuery[catType].split(',')
          for brand in brands
            applyCheckboxState(allCounters, 'brandCount', catType, brand)
        else if catType == 'priceFilters'
          hasCats = true # bad variable name, just reusing it
          priceFilters = stateQuery[catType].split(',')
          for priceFilter in priceFilters
            priceFilter = priceFilter.replace('..','_').replace('*','infinity')
            input = _docQs(_sel_priceFilter+' #range_'+priceFilter)
            if not input
              price_filter_dest = _docQs(_sel_priceFilter)
              hasFilters = price_filter_dest?.querySelector('input')
              if hasFilters
                minmax = priceFilter.split('_')
                if minmax[0] and minmax[1]
                  input = addCustomPriceRange(price_filter_dest, minmax[0], minmax[1])
              else
                allCounters.missingCheckboxCount++ # this page does not support price range filtering
            input?.checked = true
            allCounters.checkboxCount++
            allCounters.priceCount++
        else if catType == 'sort'
          input = _docQs("#result-sorts input[id=\"sorts-#{stateQuery[catType]}\"]")
          # allCounters.missingCheckboxCount++ unless input # impossible; sort choices are not invalid selections
          input?.checked = true
          allCounters.sortCount++
        else if catType == 'rating'
          input = _docQs("#result-ratings input[id=\"ratings_#{stateQuery[catType].replace('..','_')}\"]")
          allCounters.missingCheckboxCount++ unless input
          input?.checked = true
          allCounters.ratingCount++
      lastState = stateQuery
    if allCounters.sortCount < 1
      _docQs("#result-sorts input.default")?.checked = true
    if allCounters.ratingCount < 1
      _docQs("#result-ratings input.default")?.checked = true
    if not hasHistoryChanged and allCounters.missingCheckboxCount > 0 and pageConfig.dealCount > 0
      hasHistoryChanged = true # during initial page load, if we have facets or other selections we loaded server side that really aren't selectable, we will reload based on whatever IS checked
    if hasHistoryChanged # hasCats if server side loading is disabled
      facetSelectionChanged({}, callback)
    else
      indicateFacetsSelected(allCounters.checkboxCount, {
        price: allCounters.priceCount,
        facets: allCounters.facetCount,
        sorts: allCounters.sortCount,
        ratings: allCounters.ratingCount
        area: allCounters.areaCount,
        location: allCounters.locCount,
        brand: allCounters.brandCount
      })
      callback()

  setupInitialOffset = (fragmentParams, loadMoreBtn) ->
    queryOffset = fragmentParams.offset-0
    setId = fragmentParams.setId or ''
    scrollId = queryOffset
    dealHref = unescape(fragmentParams.deal)
    if not loadMoreBtn
      loadMoreBtn = _docQs(_sel_loadMoreDeals) # in rare conditions we may not find this on the page, in which case offset is probably not needed
    return unless loadMoreBtn

    offset = loadMoreBtn.getAttribute(_attr_dataNextOffset) - 0
    if offset < queryOffset

      destination = loadMoreBtn.closest('li')
      return unless destination # this should be removed soon
      loadMoreBtnA = destination.querySelector('a') # loadMoreBtnA == loadMoreBtn ...
      loadHiddenFragment = fragment()

      baseAttr = paginationCard.cloneAttributes loadMoreBtnA
      baseAttr = Object.assign baseAttr,
        'id': "load-previous-deals"
        'data-max-offset': queryOffset
        'data-next-offset': offset

      createLoadMoreButton loadHiddenFragment, null, 'load-previous-deals', baseAttr
      # todo ideally the folllowing can be moved into createLoadMoreButton somehow.... or some form of createLoadHiddenDealsBtn
      newCardLink = loadHiddenFragment.querySelector('a')
      return unless newCardLink
      remaining = queryOffset - offset
      merchName = newCardLink.querySelector('.merchant-name')
      dealTitle = newCardLink.querySelector('.deal-title')
      merchName?.textContent=I18n.pluralize remaining, _jsModulesMrchOcsn+'.hidden_deals'
      dealTitle?.textContent=I18n.t _jsModulesMrchOcsn+'.show_hidden'
      newCardLink.setAttribute 'data-bhc', newCardLink.getAttribute('data-bhc').replace(/^pagination/, 'pagination_hidden')
      label = loadMoreBtnA.getAttribute 'data-set-label'
      if label
        textNodeBefore dealTitle, label
      destination.before loadHiddenFragment
      # finally move the pagination card to the appropriate offset
      loadMoreBtn.setAttribute _attr_dataNextOffset, queryOffset
      updatePaginationCardHref(loadMoreBtn)
    loadMoreDeals loadMoreBtn, (success)->
      scrollToIt = () ->
        exact = _docQs("a[href='#{dealHref}']")
        rough = _docQs("li[data-set='#{setId}'][data-offset='#{scrollId}']")
        rough2 = _docQs("li[data-set='#{setId}']")
        rough3 = _docQs("[data-offset='#{scrollId}']")
        scrollElementIntoView(exact or rough or rough2 or rough3)
      setTimeout scrollToIt, 250

  scrollElementIntoView = (element) ->
    if element
      if typeof element.scrollIntoViewIfNeeded == 'function'
        element.scrollIntoViewIfNeeded()
      else if typeof element.scrollIntoView == 'function'
        element.scrollIntoView()

  initPaginatedDealIds = () ->
    _forEle document, 'figure.card-ui a', (dealCardLink)->
      paginatedDealIds[(dealCardLink.getAttribute('href') || '').match(/[-\w]+$/)] = true
      return if dealCardLink.classList.contains(_id_loadMoreDeals) or dealCardLink.closest('.cui-collection-pagination') # for pagination cards we do not wish to attach event 
      dealCardLink.addEventListener 'click', initiallyLoadedCardClicked # todo we should consider a single listener, this is a LOT of listeners potentially...

  resetUlCheckboxes = (ev) ->
    ev.preventDefault()
    resetLink = ev.currentTarget
    ul = resetLink.closest('.nav-heading')?.nextElementSibling
    return unless ul
    list = ul.querySelectorAll('input:checked')
    if list?.length
      _forEleList list, uncheck
      facetSelectionChangeDebounced({})
    resetLink.style.display='none'

  newHeading = (innerText, resetIdentifier) ->
    heading = domElement('div')
    heading.setAttribute('class', 'nav-heading')
    heading.setAttribute('role', 'heading')
    heading.textContent=innerText
    if resetIdentifier
      addResetLink(heading, resetIdentifier)
    return heading

  addResetLink = (heading, resetIdentifier) ->
    resetLink = newLink(I18n.t(_jsModulesMrchOcsn+'.reset'), '#', "reset #{resetIdentifier}", resetUlCheckboxes)
    resetLink.style.display="none"
    resetLink.id = "reset-facets-#{resetIdentifier}"
    resetLink.setAttribute('data-bhc', "reset-facets:#{resetIdentifier}")
    heading.appendChild(resetLink)

  newLink = (innerText, href, cssClass, clickListener) ->
    link = domElement('a')
    link.setAttribute('href', href)
    link.setAttribute('class', cssClass)
    if clickListener
      link.addEventListener('click', clickListener)
    link.textContent=innerText
    return link

  showPriceFilters = (createHeading)->
    dest = _docQs(_sel_priceFilter)
    if pageConfig.showPriceFilter and pageConfig.priceFilters and dest and (pageConfig.dealCount > 0 or initialQueryString.priceFilters)
      currencyOpts = {currencyCode: pageConfig.priceFilters.code, short:true}
      priceFilter = fragment()
      for range in pageConfig.priceFilters.ranges
        name = I18n.toCurrency(range.from, currencyOpts)
        if range.to != "*"
          name += " " + I18n.t(_jsModulesMrchOcsn+'.range_separator')
          name += " " + I18n.toCurrency(range.to, currencyOpts)
        else
          name += I18n.t(_jsModulesMrchOcsn+'.range_infinite')
        range.name = name
        range.safeTo = "#{range.to}".replace("*",'infinity')
        rangeCheckbox = fragmentFromHtml(priceRangeTemplate.render range)
        rangeCheckbox.querySelector('input')?.addEventListener('change', facetSelectionChangeDebounced)
        priceFilter.appendChild(rangeCheckbox)
      if pageConfig.allowCustomPriceRange
        addCustomPriceRange priceFilter
      dest.before(newHeading(I18n.t(_jsModulesMrchOcsn+'.price_ranges'), 'price')) if createHeading
      dest.appendChild(priceFilter)
      _docId(_touchBtnIds.price)?.style.display='' # un-hide touch nav

  addCustomPriceRange = (priceFilter, min, max) ->
    custom = _docId('range_custom')
    if custom
      _docId('custom_price_min')?.value=min
      _docId('custom_price_max')?.value=max
      computeCustomRange()
      return custom
    range = {
      min: min || "",
      max: max || "",
      name: I18n.t(_jsModulesMrchOcsn+'.range_separator')
    }
    rangeCheckbox = fragmentFromHtml(priceRangeCustTemplate.render range)
    checkItself = rangeCheckbox.querySelector('input#range_custom')
    checkItself?.addEventListener('change', facetSelectionChangeDebounced)
    _forEle rangeCheckbox, 'input.custom-price-range', (n) ->
      n.addEventListener('click', numberInputClicked, true)
      n.addEventListener('change', customPriceRangeChanged)
      n.addEventListener('keyup', customPriceRangeChanged)
    priceFilter.appendChild(rangeCheckbox)
    if min and max
      computeCustomRange()
    return checkItself

  computeCustomRange = () ->
    custom = _docId('range_custom')
    return unless custom
    checked = custom.checked
    min = _docId('custom_price_min').value || '0'
    max = _docId('custom_price_max').value || Infinity
    if Math.max(min, max)+'' == min # user reversed range
      oldMax = max
      max = min
      min = oldMax
    range = (max-0) - (min-0)
    if !min || !max || range <= 0 || (min == '0' && range == Infinity)
      custom.checked = false
      return false
    else
      max = '*' if max == Infinity
      custom.setAttribute('data-range', "#{min}..#{max}")
      return true

  customPriceRangeChanged = (ev) ->
    return if ev.keyCode in [9, 16, 37, 39] # 9 tab key, 16 shift key, 37 left arr, 39 right arr
    custom = _docId('range_custom')
    checked = custom.checked
    custom.checked = false
    minEl = _docId('custom_price_min')
    maxEl = _docId('custom_price_max')
    minEl.value = minEl.value || '' # number fields will report empty value for non numeric input... clear the field in that case
    maxEl.value = maxEl.value || ''
    if checked
      facetSelectionChangeDebounced({})
    if ev.keyCode == 13
      if computeCustomRange() # enter key and valid range
        custom.checked = true
        facetSelectionChangeDebounced({})

  numberInputClicked = (ev) ->
    ev.preventDefault(); # this works around a Safari issue where clicking on the number input field inside the label will also click the label - other browsers seem to be okay with this change (text can still be entered and the cursor positioned in the field)
    ev.stopPropagation();
    return false;

  showSortOptions = (createHeading)->
    dest = _docId('result-sorts')
    if pageConfig.showPriceFilter and pageConfig.sorts and dest and pageConfig.dealCount > 0
      sorts = fragment()
      for sort in pageConfig.sorts
        sortRadio = fragmentFromHtml(radioTemplate.render Object.assign(sort, {type: 'sorts'}))
        sortRadio.querySelector('input').addEventListener('change', facetSelectionChangeDebounced)
        sorts.appendChild(sortRadio)
      dest.before(newHeading(I18n.t(_jsModulesMrchOcsn+'.sort_by'))) if createHeading
      dest.appendChild(sorts)
      _docId(_touchBtnIds.sorts)?.style.display='' # un-hide touch nav

  showRatingFilters = (createHeading)->
    dest = _docId('result-ratings')
    if pageConfig.showRatingFilter and dest and pageConfig.dealCount > 0
      _forEle dest, 'input', (radio) ->
        radio.addEventListener('change', facetSelectionChangeDebounced)
      dest.before(newHeading(I18n.t(_jsModulesMrchOcsn+'.ratings'))) if createHeading
      dest.style.display='' # un-hide web choices
      _docId(_touchBtnIds.ratings)?.style.display='' # un-hide touch nav

  createFacetCheckbox = ( destNode, facet, changeEv ) ->
    facetNode = fragmentFromHtml(facetTemplate.render facet)
    input = facetNode.querySelector('input')
    input.addEventListener('change', changeEv)
    destNode.appendChild(facetNode)
    return input

  showSubnavBrandFacets = (dataSource, createHeading) ->
    facetAreaFacets = lhnFacets.loadedFacets[dataSource]
    dest = _docId('brand-filters')
    if facetAreaFacets.length and dest
      facetArea = fragment()
      for facet in facetAreaFacets
        createFacetCheckbox(facetArea, facet, facetSelectionChangeDebounced)
      dest.before(newHeading(I18n.t(_jsModulesMrchOcsn+'.brands'), 'brand')) if createHeading
      dest.appendChild(facetArea)
      _docId(_touchBtnIds.brand)?.style.display='' # un-hide touch nav
      if pageConfig.brandFacetsMoreLink && lhnFacets.remainingLoadedFacets[dataSource].length > 0
        addMoreLink(dest, dataSource, 'brand-filters', I18n.t(_jsModulesMrchOcsn+'.brands'))

  showSubnavLocationFacets = (dataSource, createHeading) ->
    facetAreaFacets = lhnFacets.loadedFacets[dataSource]
    dest = _docId('location-filters')
    if facetAreaFacets.length and dest
      facetArea = fragment()
      for facet in facetAreaFacets
        createFacetCheckbox(facetArea, facet, facetSelectionChangeDebounced)
      dest.before(newHeading(I18n.t(_jsModulesMrchOcsn+'.location'), 'location')) if createHeading
      dest.appendChild(facetArea)
      _docId(_touchBtnIds.location)?.style.display='' # un-hide touch nav
      if pageConfig.locationFacetsMoreLink && lhnFacets.remainingLoadedFacets[dataSource].length > 0
        addMoreLink(dest, dataSource, 'location-filters', I18n.t(_jsModulesMrchOcsn+'.location'))

  showSubnavAreaFacets = (facetAreaFacets, createHeading) ->
    dest = _docId('facet-area-filters')
    if facetAreaFacets.length and pageConfig.subnavFacetAreaTitle and dest
      facetArea = fragment()
      for facet in facetAreaFacets
        createFacetCheckbox(facetArea, facet, facetSelectionChangeDebounced)
      dest.before(newHeading(pageConfig.subnavFacetAreaTitle, 'area')) if createHeading
      dest.appendChild(facetArea)
      _docId(_touchBtnIds.area)?.style.display='' # un-hide touch nav

  showSubnavFacets = (dataSource) ->
    subnavFacets = lhnFacets.loadedFacets[dataSource]
    liHolder = _docId('facet-filters')
    if subnavFacets.length and pageConfig.showSubnavFacets and liHolder
      for facet in subnavFacets
        createFacetCheckbox(liHolder, facet, facetSelectionChangeDebounced)
      navHeading = liHolder.previousElementSibling
      if navHeading
        if navHeading.matches('.nav-heading')
          navHeading.style.display='' # un-hide
          addResetLink(navHeading, 'facets')
      liHolder.classList.add('nav-facets')
      liHolder.style.display='' # un-hide
      _docId(_touchBtnIds.facets)?.style.display='' # un-hide touch nav
      if pageConfig.subnavFacetsMoreLink && lhnFacets.remainingLoadedFacets[dataSource].length > 0
        addMoreLink(liHolder, dataSource, 'facet-filters', I18n.t(_jsModulesMrchOcsn+'.categories'))

  addMoreLink = (dest, dataType, origLoc, eventualTitle) ->
    li = domElement('li')
    link = newLink(I18n.t(_jsModulesMrchOcsn+'.more_ellipsis'), '#', 'match-check-indent', showMoreFacets)
    link.setAttribute('data-bhc', 'more:' + origLoc)
    link.setAttribute('data-type', dataType)
    link.setAttribute('data-orig-location', origLoc)
    link.setAttribute('data-title', eventualTitle)
    li.appendChild(link)
    dest.appendChild(li)

  showMoreFacets = (ev) ->
    ev.preventDefault()
    target = ev.currentTarget
    dataSource = target.getAttribute('data-type')
    dataOrigLocation = target.getAttribute('data-orig-location')
    titleText = target.getAttribute('data-title')
    if pageConfig.isTouch
      origDest = _docId(dataOrigLocation)
      target.closest('li').remove()
      if lhnFacets.remainingLoadedFacets[dataSource].length
        for facet in lhnFacets.remainingLoadedFacets[dataSource]
          createFacetCheckbox(origDest, facet, facetSelectionChangeDebounced)
    else
      morePane = _docId('more-filters-modal-content')
      paginationCard.copyDataAttributes(target, morePane)
      if morePane && lhnFacets.allLoadedFacets?[dataSource]?.length
        list = domElement('ul')
        morePane.innerHTML = ''
        if lhnFacets.searchFacets[dataSource].moreAlphaSort
          lhnFacets.allLoadedFacets[dataSource].sort(lhnFacets.alphaSort)
        for facet in lhnFacets.allLoadedFacets[dataSource]
          input = createFacetCheckbox(list, facet, checkboxInModalClicked)
          exi = _docQs('.gift-sidebar #'+input.id)
          if exi && exi.checked
            input.checked = true
          fixModalLabelIds(input.closest('li'), true)
        _docId('more-filters-modal-title')?.innerText = titleText
        morePane.appendChild(list)
        GIG.Modal.open({id:'more-filters-modal'})

  fixModalLabelIds = (list, add) ->
    input = list.querySelector('input')
    if add
      input.id = 'modal-' + input.id # isolate IDs
    else
      input.id = input.id.replace(/^modal-/, '')
    list.querySelector('label').setAttribute('for', input.id)

  checkboxInModalClicked = (ev) ->
    input = ev.currentTarget
    context = input.closest('.container');
    dataOrigLocation = context.getAttribute('data-orig-location')
    origDest = _docId(dataOrigLocation)
    origId = input.id.replace(/^modal-/, '')
    origCheck = origDest.querySelector('#'+origId)
    if origCheck
      origCheck.checked = input.checked
    else
      clone = input.closest('li').cloneNode(true) # attach events to clone
      clone.querySelector('input').addEventListener('change', facetSelectionChangeDebounced)
      fixModalLabelIds(clone)
      origDest.lastChild.before(clone)
    facetSelectionChangeDebounced({})

  getDivisionLatLng = () ->
    return paginationCard.getDivisionLatLng(pageConfig)

  getDivisionLocale = () ->
    return paginationCard.getDivisionLocale(pageConfig)

  getSelectableCategories = () ->
    getCategoriesForCheckboxes('.nav-facets input')

  getSelectedCategories = () ->
    getCategoriesForCheckboxes('.nav-facets input:checked')

  getFacetAreaCategories = () ->
    getCategoriesForCheckboxes('#facet-area-filters input:checked')

  getFacetBrands = () ->
    getCategoriesForCheckboxes('#brand-filters input:checked')

  getFacetLocations = () ->
    getCategoriesForCheckboxes('#location-filters input:checked', true)

  getCategoriesForCheckboxes = (selector, groupByType) ->
    foundCats = []
    queryCats = {all: []}
    mappedCats = {}
    _forEle document, selector, (chk) ->
      catType = chk.getAttribute('data-category-type')
      name = chk.getAttribute('data-category-name')
      cat =  chk.getAttribute('data-category')
      query = catType + ':' + cat
      typeKey = if groupByType then catType else 'all'
      if not queryCats[typeKey]
        queryCats[typeKey] = []
      queryCats[typeKey].push(query)
      foundCats.push
        type: catType
        id: cat
        name: name
        query: query
      if not mappedCats[catType]
        mappedCats[catType] = cat
      else mappedCats[catType] += ",#{cat}"
    if groupByType
      catQueries = [];
      for catType of queryCats
        if queryCats[catType].length
          catQueries.push("("+queryCats[catType].join(" OR ")+")")
      catQuery = catQueries.join(" AND ");
    else
      catQuery = queryCats['all'].join(" OR ")
    {foundCats, mappedCats, catQuery}

  getSelectedPriceRanges = () ->
    computeCustomRange()
    foundRanges = []
    mappedRanges = {}
    priceFilter = ""
    _forEle document, _sel_priceFilter+' input:checked', (chk) ->
      foundRanges.push chk.getAttribute('data-range')
    if foundRanges.length
      priceFilter = " AND price:["+foundRanges.join('];[')+"]"
      mappedRanges.priceFilters = foundRanges.join(',')
    {priceRanges: foundRanges, mappedRanges, priceFilter}

  getSelectedSortMap = () ->
    map = {}
    sort = urlUtils.getSelectedSort()
    map.sort = sort if sort
    return map

  getSelectedRatingMap = () ->
    ratingMap = {}
    ratingRanges = []
    ratingFilter = ""
    rating = urlUtils.getSelectedRating()
    if rating
      ratingMap.rating = rating
      ratingRanges.push(rating)
      ratingFilter = " AND rating:["+rating+"]"
    return {ratingRanges, ratingMap, ratingFilter}

  indicateFacetsSelected = (totalSelections, changeMeta) ->
    responsiveBtn = _docQs('#sidebar-toggle button')
    if responsiveBtn
      if totalSelections > 0
        responsiveBtn.textContent=I18n.pluralize(totalSelections, _jsModulesMrchOcsn+'.options_selected')
      else
        responsiveBtn.textContent=I18n.t(_jsModulesMrchOcsn+'.options_title')
      for metaType of _touchBtnIds
        _docId("reset-facets-#{metaType}")?.style.display = if !!changeMeta[metaType] then 'inline-block' else 'none'
    else # touch
      for metaType of _touchBtnIds
        touchToggleButton(_docId(_touchBtnIds[metaType]), !!changeMeta[metaType])

  touchToggleButton = (button, state) ->
    if button
      button.classList.toggle('c-bg-prim', state)
      button.classList.toggle('active', state)

  urlTemplateBuilder = (urlPath, setId) ->
    url = pageConfig.occasion.permalink + urlPath + '#offset={OFFSET}'
    if setId
      url += "&setId=" + setId
    return url

  updatePaginationCardHref = (loadMoreBtn) ->
    newHref = loadMoreBtn.getAttribute(_attr_dataHrefTemplate)
    if !newHref
      newHref = urlTemplateBuilder("")
    newHref = paginationTemplateUrlSetOffset(newHref, loadMoreBtn.getAttribute(_attr_dataNextOffset))
    loadMoreBtn.setAttribute("href", newHref)

  paginationTemplateUrlSetOffset = (href, offset) ->
    return href.replace('{OFFSET}', offset)

  getHeroDealNode = () ->
    return _docId('heroContainer')

  getCurrentDealNodes = () ->
    return _docQsAll('#result-list > ul > li')

  lastUl = () ->
    return _docQs('#result-list > ul:last-of-type')

  getErrorNode = () ->
    return _docId('nodeals') || _docId('collection-sold-out-holder')

  updateLoading = (opacity, display) ->
    results = _docId('result-list');
    if results
      results.style.opacity = opacity;
    loading = _docId('loading');
    if loading
      loading.style.display = display

  loadingDeals = () ->
    updateLoading 0.5, 'block'

  notLoadingDeals = () ->
    updateLoading 1.0, 'none'

  facetSelectionChanged = (ev, callbackFn) ->
    subnavFacetState = getSelectedCategories()
    {foundCats, mappedCats, catQuery} = subnavFacetState
    facetAreaState = getFacetAreaCategories()
    facetBrandState = getFacetBrands()
    facetLocState = getFacetLocations()
    {priceRanges, mappedRanges, priceFilter} = getSelectedPriceRanges()
    sortMap = getSelectedSortMap()
    {ratingRanges, ratingMap, ratingFilter} = getSelectedRatingMap()
    stateMap = Object.assign({}, mappedRanges, mappedCats, sortMap, ratingMap, facetAreaState.mappedCats, facetBrandState.mappedCats, facetLocState.mappedCats)
    urlPath = urlUtils.buildQueryString stateMap

    {filterQuery, totalSelections} = new QueryBuilder("(#{pageConfig.occasion.apiRapiFilterDefault})" or "deal_type:#{pageConfig.occasion.dealType}")
      .extend(subnavFacetState)
      .extend(facetAreaState)
      .extend(facetBrandState)
      .extend(facetLocState)
      .extendSimple(priceRanges, priceFilter)
      .extendSimple(ratingRanges, ratingFilter)
      .finalize()

    latLng = getDivisionLatLng()
    divisionLocale = getDivisionLocale()

    indicateFacetsSelected(totalSelections, {
      price: priceRanges.length,
      facets: foundCats.length,
      sorts: sortMap.sort,
      ratings: ratingMap.rating,
      area: facetAreaState.foundCats.length,
      location: facetLocState.foundCats.length,
      brand: facetBrandState.foundCats.length
    })

    query_filter_string = urlUtils.apiQueryBuilder Object.assign({
      filterQuery: filterQuery
    }, paginationCard.campaignFilteringAttrs(pageConfig))

    offset = 0
    limit = pageConfig.pageLimit

    heroDeal = getHeroDealNode()
    nodesToClearOnSuccess = getCurrentDealNodes()

    loadMoreBtnA = createLoadMoreButton lastUl(), false, false,
      'data-filter-query': filterQuery
      'data-division-loc': latLng
      'data-href-template': urlTemplateBuilder(urlPath)
    return unless loadMoreBtnA
    loadMoreBtn = loadMoreBtnA.closest('li')

    loadMoreBtn.style.display = 'none' # avoid duplicate loading spinners...

    oldPaginatedIds = paginatedDealIds
    paginatedDealIds = {} # if the load is successful, we clear the prior results, so do not dedupe against them, we'll set this back later if the results fail to load
    loadingDeals()

    loadDeals loadMoreBtnA, query_filter_string, offset, limit, false, nodesToClearOnSuccess, heroDeal, (success, dupe) ->
      loadMoreBtn.style.display = ''
      notLoadingDeals()
      if success
        newState = {stateQuery:stateMap}
        if history.pushState and not objectsMatch(history.state, newState) # we should not push state if our current state is already represented (initial page load time)
          lastState = stateMap
          history.pushState(newState,document.title,window.location.pathname + urlPath) # + urlUtils.currentFragment() # if we do not drop the fragment, we should make sure to at least set the offset to 0
        OptimizeSuite.treatAsNewPage(window.location.pathname + urlPath)
        callbackFn?()
      else
        paginatedDealIds = oldPaginatedIds unless dupe
        loadMoreBtn.remove()

  # the debounced version of facetSelectionChanged will only be called once per given interval, allows us to react only once to many changes
  facetSelectionChangeDebounced = basicDebounce(facetSelectionChanged, 400)

  textNode = (text) ->
    document.createTextNode(text)

  domElement = (name) ->
    document.createElement(name)

  fragment = () ->
    document.createDocumentFragment()

  fragmentFromHtml = (html) ->
    document.createRange().createContextualFragment(html)

  textNodeBefore = (elm, text) ->
    if elm
      elm.insertBefore(domElement('br'), elm.firstChild);
      elm.insertBefore(textNode(text), elm.firstChild);

  initiallyLoadedCardClicked = (ev) ->
    a = ev.currentTarget
    href = a.getAttribute 'href'
    if href
      urlUtils.setFragment "deal=#{escape(href)}"

  clonedCardClicked = (ev) ->
    target = ev.currentTarget
    a = target.querySelector('a')
    offset = target.getAttribute 'data-offset'
    href = escape(a.getAttribute 'href')
    extraFilter = getExtraFilter(a)
    urlUtils.setFragment "offset=#{offset}&deal=#{href}#{extraFilter}"

  scrollUpIfNeeded = (target)->
    scrolly = window.pageYOffset
    offset = target.getBoundingClientRect()
    btnPosition = (offset.top + scrolly) - 60
    if( btnPosition < scrolly )
      window.scrollBy(0, btnPosition - scrolly)

  loadMoreDealsEvent = (ev, optionalCbf)->
    ev?.preventDefault()
    loadMoreBtn = ev.currentTarget
    scrollUpIfNeeded loadMoreBtn
    loadMoreDeals loadMoreBtn, optionalCbf
    offset = loadMoreBtn.getAttribute(_attr_dataNextOffset) - 0
    extraFilter = getExtraFilter(loadMoreBtn)
    if offset or extraFilter
      urlUtils.setFragment "offset=#{offset}#{extraFilter}" # if we are using push state, we neeed to be careful here, to see if anything actually changed before trying to load anything

  getExtraFilter = (a)->
    extraFilter = ''
    setId = a.getAttribute(_attr_dataSetId)
    if setId
      extraFilter = "&setId=#{setId}"
    return extraFilter

  loadMoreDeals = (loadMoreBtn, callbackFn) ->
    query_filter_string = urlUtils.apiQueryBuilder paginationCard.loadButtonAttributes(loadMoreBtn, pageConfig)
    offset = loadMoreBtn.getAttribute(_attr_dataNextOffset) - 0
    limit = (loadMoreBtn.getAttribute("data-limit") - 0) or 99
    maxOffset = loadMoreBtn.getAttribute("data-max-offset") - 0
    # return unless offset and offset > 0
    loadDeals loadMoreBtn, query_filter_string, offset, limit, maxOffset, [], false, callbackFn

  loadNextPage = (onlyRemainingPage1) ->
    return if fragmentParams.offset and onlyRemainingPage1
    loadMoreBtn = _docId(_id_loadMoreDeals)
    if loadMoreBtn
      nextOffset = loadMoreBtn.getAttribute('data-next-offset')
      return if nextOffset < 1 # zero cards from initial load... don't try to finish loading
      origLimit = loadMoreBtn.getAttribute('data-limit')
      if onlyRemainingPage1
        remainingPage1 = origLimit - (pageConfig.pageLimitUsed || 0)
        return unless remainingPage1 > 0
        loadMoreBtn.setAttribute('data-limit', remainingPage1)
      loadMoreDeals loadMoreBtn, (success, dupe)->
        loadMoreBtn.setAttribute('data-limit', origLimit)

  heroReadyToShow = (hero, paginatedKey) ->
    hero.style.display = ''
    paginatedDealIds[paginatedKey] = true

  setLoadingStatus = (loadMoreFigure, status) ->
    loadMoreFigure.classList.remove('retry')
    loadMoreFigure.classList.remove('loading')
    loadMoreFigure.classList.add(status) if status

  checkRemainingDeals = (total, offset, limit) ->
    remaining = total - offset
    moreDeals = true
    if total and (remaining <= (limit+MIN_PAGE_DEALS))
      moreDeals = false
    return moreDeals

  cardsForResp = (json) ->
    return json.deals or json.cards

  htmlForDeal = (deal) ->
    return deal.cardHtml

  dataForDeal = (deal) ->
    return deal.data or deal

  metaForDeal = (deal) ->
    dealData = dataForDeal(deal)
    paginatedKey = if dealData.optionUuid then dealData.id + '_' + dealData.optionUuid else dealData.id
    return {dealData: dealData, cardHtml: htmlForDeal(deal), paginatedKey: paginatedKey}

  loadDeals = (loadMoreBtn, query_filter_string, offset, limit, maxOffset, toRemoveOnSuccess, optionalHero, callbackFn) ->
    loadMoreParentLi = loadMoreBtn.closest('li')
    loadMoreFigure = loadMoreBtn.closest('figure')
    setLoadingStatus(loadMoreFigure, 'loading')
    setId = loadMoreBtn.getAttribute(_attr_dataSetId) or ''
    total = loadMoreBtn.getAttribute(_attr_dataTotalDeals) - 0
    remainingDeals = checkRemainingDeals(total, offset, limit)
    if !remainingDeals
      limit += LIMIT_INCREMENT
    url = "/occasion/deals-json?#{query_filter_string}&offset=#{offset}&limit=#{limit}" + extraQueryString
    lastRequest = url
    _docId(_id_pagination_facets_loading)?.remove() # we are in flight loading pagination cards while user checked another box, cancel the results

    fetch(url, {
      method: 'GET',
      headers: {'Content-Type': 'application/json', 'referer': window.location.href},
      credentials: 'include'
    }).then((res)->
      if !res.ok # make sure xhr succeeded
          throw("Fetch returned statuscode: #{res.statusCode}")
      return res.json()
    ).then((json)->
        setLoadingStatus(loadMoreFigure, false)
        errNode = getErrorNode()
        if errNode
          errNode.remove()
        if lastRequest != url
          # another subsequent request is newer, skip this
          callbackFn?(false, true)
          return
        cards = cardsForResp json
        if cards
          r = 0
          rl = cards.length
          total = json.pagination.count
          newOffset = json.pagination.nextOffset
          if not setId # touch indicates result count
            _forEle document, '.result-count', (el)->
              el.textContent=I18n.pluralize(total, _jsModulesMrchOcsn+'.view_deals_count')
          if toRemoveOnSuccess.length
            toRemoveOnSuccess.forEach (e)->
              e.remove()
          if optionalHero
            if rl > 0
              {dealData, cardHtml, paginatedKey} = metaForDeal cards[r]
              if cardHtml
                optionalHero.innerHTML = ''
                newCard = fragmentFromHtml(cardHtml)
                optionalHero.appendChild(newCard)
                heroReadyToShow(optionalHero, paginatedKey)
                getCardUi().init(optionalHero)
                if pageConfig.isTouch
                  window.scrollTo(0,0)
                r++
              else
                optionalHero.style.display = 'none'
            else
              optionalHero.style.display = 'none'
          if newOffset == offset # we didn't acutally get any new deals back from the request... API lied about the total
            outOfDeals(loadMoreParentLi, total)
            callbackFn?(true)
            return
          loadMoreBtn.setAttribute(_attr_dataNextOffset, newOffset)
          loadMoreBtn.setAttribute(_attr_dataTotalDeals, total)
          updatePaginationCardHref(loadMoreBtn)
          while r < rl
            {dealData, cardHtml, paginatedKey} = metaForDeal cards[r]
            if not paginatedDealIds[paginatedKey]
              if cardHtml
                newCard = fragmentFromHtml(cardHtml)
                newCardA = newCard.querySelector('a')
                if newCardA
                  newCardA.setAttribute('data-limit', 1) # supports same integration test in if cardHtml branch
                  newCardA.setAttribute(_attr_dataSetId, setId)
                newCardLi = newCard.querySelector('li')
                if not newCardLi
                  newCardLi = domElement('li')
                  newCardLi.appendChild(newCard)
                loadMoreParentLi.before(newCardLi)

                newCardLi.addEventListener 'click', clonedCardClicked
                newCardLi.setAttribute 'data-offset', offset
                newCardLi.setAttribute 'data-set', setId if setId
                paginatedDealIds[paginatedKey] = true
            r++
          Groupon.Utils.lazyLoadImages()
          getCardUi().init(_docId('result-list'))
          if offset + rl >= total or newOffset >= total or (maxOffset and newOffset >= maxOffset)
            outOfDeals(loadMoreParentLi, total)
          else
            if maxOffset
              remaining = maxOffset - newOffset
              loadMoreBtn.querySelector('.merchant-name')?.textContent=I18n.pluralize(remaining, _jsModulesMrchOcsn+'.hidden_deals')
            else
              remaining = total - newOffset
              loadMoreBtn.querySelector('.merchant-name')?.textContent=I18n.pluralize(remaining, _jsModulesMrchOcsn+'.remaining_deals')
          callbackFn?(true)
    ).catch((error)-> # Error handling
      setLoadingStatus(loadMoreFigure, 'retry')
      callbackFn?(false)
    )

  outOfDeals = (loadMoreParentLi, total) ->
    ulContainer = loadMoreParentLi.closest('ul')
    loadMoreChoices = _docQsAll(_sel_loadMoreChoices)
    loadMorePaginationCard = loadMoreParentLi.querySelectorAll(_sel_loadMoreChoices)
    loadMoreParentLi.remove()
    if loadMoreChoices.length == 0 # we may have just removed the last .load-more-choices, but we still counted it first, so we will not create them more than once
      showLoadMoreChoicesBtns(ulContainer)
    destNode = getHeroDealNode() || lastUl()
    if loadMorePaginationCard.length < 1 && total < 1 && !getErrorNode() && destNode
      destNode.before fragmentFromHtml('<div id="nodeals" class="no_deals"><div class="message">'+pageConfig.error+'</div></div>')
      if pageConfig.isTouch
        window.scrollTo(0,0)

  loadFacets = (loadMoreBtn, query_filter_string, successCb) ->
    loadMoreParentLi = loadMoreBtn.closest('li')
    loadMoreFigure = loadMoreBtn.closest('figure')
    setLoadingStatus(loadMoreFigure, 'loading')
    url = "/occasion/deals-json?#{query_filter_string}&offset=0&limit=0" + extraQueryString
    fetch(url, {
      method: 'GET',
      headers: {'Content-Type': 'application/json', 'referer': window.location.href},
      credentials: 'include'
    }).then((res)->
      if !res.ok # make sure xhr succeeded
          throw("Fetch facets returned statuscode: #{res.statusCode}")
      return res.json()
    ).then((json)->
      stillInDoc = loadMoreParentLi.parentNode # if the card goes away we know the user did something and we will cancel
      loadMoreParentLi.remove()
      if stillInDoc && json.facets
        successCb?(json.facets)
    ).catch((error)-> # Error handling
      stillInDoc = loadMoreParentLi.parentNode
      loadMoreParentLi.remove()
      if stillInDoc
        successCb?(null) # we will just show all pagination cards possible...
    )

  showLoadMoreChoicesBtns = (ulContainer, initialLoadFragmentParams) ->
    return unless pageConfig.showMoreChoices
    loadMoreChoices = _docQsAll(_sel_loadMoreChoices)
    return unless loadMoreChoices.length == 0
    subnavFacetState = getSelectedCategories()
    {foundCats, mappedCats} = subnavFacetState
    facetAreaState = getFacetAreaCategories()
    facetBrandState = getFacetBrands()
    facetLocState = getFacetLocations()
    {priceRanges, mappedRanges, priceFilter} = getSelectedPriceRanges()
    {ratingRanges, ratingMap, ratingFilter} = getSelectedRatingMap()
    stateMap = Object.assign({}, mappedRanges, mappedCats, getSelectedSortMap(), ratingMap)
    urlPath = urlUtils.buildQueryString stateMap
    latLng = getDivisionLatLng()
    if foundCats.length
      setId = 'dealtype'
      hrefTemplate = urlTemplateBuilder(urlPath, 'dealtype')
      createLoadMoreButton ulContainer, pageConfig.occasion.displayName, _cls_loadMoreChoices,
        id: _id_loadMoreDeals+"-from-#{setId}"
        'data-set-id': setId
        'data-nohero': true
        'load_all': true # since we are not applying filtering; loadAll will cause the template to render a different message on this card
        'data-href-template': hrefTemplate
        'href': paginationTemplateUrlSetOffset(hrefTemplate, '0')
        'data-division-loc': latLng
    else
      {foundCats} = lhnFacets.getCategories('paginationFacets')
      if not foundCats.length
        {foundCats} = getSelectableCategories()
    if foundCats.length
      _docId(_id_pagination_facets_loading)?.remove()

      unseenDealsFilter = "(NOT (#{pageConfig.occasion.apiRapiFilterDefault}))" or "(NOT deal_type:#{pageConfig.occasion.dealType})"
      # we now wish to check which cats have the needed inventory
      # we can make a single call for facets to accomplish this
      # we will show a pagination card on the page to indicate these are "loading"
      {filterQuery, totalSelections} = new QueryBuilder(unseenDealsFilter)
        .extend(facetAreaState)
        .extend(facetBrandState)
        .extend(facetLocState)
        .extendSimple(priceRanges, priceFilter)
        .extendSimple(ratingRanges, ratingFilter)
        .finalize()

      loadingIndicator = createLoadMoreButton ulContainer, "", _cls_loadMoreChoices,
        'id': _id_pagination_facets_loading
        'data-set-id': ''
        'data-nohero': true
        'already_loading': true
        'data-filter-query': filterQuery
        'data-division-loc': latLng
        'data-href-template': hrefTemplate
        'href': '#'

      query_filter_string = urlUtils.apiQueryBuilder paginationCard.loadButtonAttributes(loadingIndicator, pageConfig)
      loadFacets(
        loadingIndicator,
        query_filter_string,
        (facets)->
          if facets # if we got facets back, lets show pagination cards only for the ones that have inventory
            seekFacets = []
            for foundCat in foundCats
              seekFacets.push foundCat.id
            # console.log("success facets:", facets, "foundcats:", foundCats, "seeking:", seekFacets )
            moreFacets = new FacetLoader(facets, {
              paginationFacets: {
                searchList: seekFacets
                require: pageConfig.paginationFacetsMinimumDeals || pageConfig.subnavFacetsMinimumDeals
                max: pageConfig.paginationFacetsMax
              }
            })
            foundCats = moreFacets.loadedFacets.paginationFacets
          # console.log("found cats (valid pagination cards):", foundCats )
          for cat in foundCats
            baseFilter = "(#{cat.query})"
            if facets # if we got facets back, the unseenDealsFilter works
              baseFilter = "(#{unseenDealsFilter} AND #{cat.query})"
            {filterQuery, totalSelections} = new QueryBuilder(baseFilter)
              .extend(facetAreaState)
              .extend(facetBrandState)
              .extend(facetLocState)
              .extendSimple(priceRanges, priceFilter)
              .extendSimple(ratingRanges, ratingFilter)
              .finalize()

            hrefTemplate = urlTemplateBuilder(urlPath, cat.id)
            createLoadMoreButton ulContainer, cat.name, _cls_loadMoreChoices,
              'id': _id_loadMoreDeals+"-from-#{cat.id}"
              'data-set-id': cat.id
              'data-nohero': true
              'data-filter-query': filterQuery
              'data-division-loc': latLng
              'data-href-template': hrefTemplate
              'href': paginationTemplateUrlSetOffset(hrefTemplate, '0')
              # we may want to set the href to support open pagination card in new tab

          if initialLoadFragmentParams
            fragmentParams = initialLoadFragmentParams
            loadMoreBtn = _docQs(_sel_loadMoreChoices+_sel_loadMoreDeals+'-from-'+fragmentParams.setId)
            if loadMoreBtn
              setupInitialOffset fragmentParams, loadMoreBtn

      )

  createLoadMoreButton = ( container, title, className, extraAttr ) ->
    return unless container
    paginationBhc = "dealType-" + pageConfig.occasion.dealType
    if extraAttr[_attr_dataFilterQuery]
      paginationBhc = "filter-" + escape(extraAttr[_attr_dataFilterQuery])
    else if pageConfig.occasion.isCategoryFallback and pageConfig.occasion.categoryFallback
      paginationBhc = "catFallback-" + escape(pageConfig.occasion.categoryFallback)
    loadMoreBtn = fragmentFromHtml(loadMoreTemplate.render I18n.mixin(loadAll: extraAttr.load_all, campaign: pageConfig.occasion, pageLimit: pageConfig.pageLimit, newRenderEnabled: pageConfig.newRender, allowRapi: true, nextOffset: 0, paginationBhc: paginationBhc), hoganPartials)
    loadMoreBtnA = loadMoreBtn.querySelector('a'+_sel_loadMoreDeals)
    if className
      loadMoreBtnA.classList.add className # note single class only!
    if title
      textNodeBefore loadMoreBtnA.querySelector('.deal-title'), title
      loadMoreBtnA.setAttribute('data-set-label', title)
    for key, value of extraAttr
      loadMoreBtnA.setAttribute(key, value)
    if !extraAttr['href'] and extraAttr[_attr_dataHrefTemplate]
      loadMoreBtnA.setAttribute('href', paginationTemplateUrlSetOffset(extraAttr[_attr_dataHrefTemplate], '0'))
    if extraAttr.already_loading
      loadMoreBtnA.querySelector('.cui-cta-container')?.style.visibility='hidden'
    else
      loadMoreBtnA.addEventListener('click', loadMoreDealsEvent)
    container.appendChild(loadMoreBtn)
    return loadMoreBtnA

  return {
    init: _init
    initCui: initCui
    getCardUi: getCardUi
    loadNextPage: loadNextPage
    loadMoreDealsEvent: loadMoreDealsEvent
    cardsForResp: cardsForResp
    htmlForDeal: htmlForDeal
    dataForDeal: dataForDeal
    facetSelectionChanged: facetSelectionChangeDebounced
    paginatedDealIds: paginatedDealIds
    lhnFacets: lhnFacets
  }

window.MerchFiltering = Filtering
module.exports = Filtering
